<template>
<div>工具分类编辑</div>
</template>

<script>
export default {
  name: "tool-category-edit"
}
</script>

<style scoped>

</style>